'use strict';

angular.module('app.entity.field.audit').controller('FieldAuditController', [
    '$stateParams',
    'RecordDataService',
    'CrdConfigurationService',
    'ShareCrfSDK',
    '$log',
    function($stateParams, RecordDataService,  CrdConfigurationService, ShareCrfSDK ,$log) {
        var vm = this;

        /**
         * Bindings
         * - vm.fieldId
         * - vm.entityVersion
         */

        vm.fieldAudit = [];
        vm.hasAudit = false;
        vm.error = null;
        vm.loaded = false;

        vm.showReason = CrdConfigurationService.getAudit().hasReason();

        var fieldUId;

        function sameUId(left, right) {
            if (left.length !== right.length) {
                return false;
            }
            for (var i = 0,ii = left.length;i < ii;i++) {
                if (left[i] != right[i]) {
                    return false;
                }
            }

            return true;
        }

        function getFieldAudit() {
            var field = RecordDataService.getCRF().getField(vm.fieldId);

            ShareCrfSDK.ecrd.getRecordAuditLog($stateParams.recordId)
                .then(function(audit) {
                    vm.fieldAudit = audit.reduce(function(acc, item) {
                        // filtramos por el UID del campo (como array)
                        item.change = item.change.reduce(function(itemAcc, change) {
                            // los cambios que no tengan UID seguro que no se corresponden con este campo
                            if (change.uid && sameUId(change.uid, fieldUId)) {
                                if (field.getFormControl() === 'files') {
                                    change.format = 'fieldfiles';
                                } else if (field.getFormControl() === 'dicom') {
                                    change.format = 'dicom';
                                }
                                itemAcc.push(change);
                            }

                            return itemAcc;
                        }, []);

                        // quitamos finalmente las líneas de audit que no contengan ningún cambio relacionado
                        if (item.change.length > 0) {
                            acc.push(item);
                        }

                        return acc;
                    }, []);

                    vm.loaded = true;
                });
        }

        vm.$onInit = function() {
            $log.debug('Entity version', vm.entityVersion);
            var listIndices = RecordDataService.getCRF().getListIndices($stateParams);
            fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);

            getFieldAudit();
        };

        vm.$onChanges = function(changes) {
            if (angular.isDefined(changes.entityVersion) && !changes.entityVersion.isFirstChange()) {
                vm.loaded = false;
                $log.debug(changes);
                // se ha actualizado la entidad, por precaución recargamos el audit del campo
                getFieldAudit();
            }
        };
    },
]);
